import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Store } from '@ngrx/store';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { CompanyService } from 'src/app/services/company.service';
//import { FroalaEditorOptions } from '../../../data/constants/froala-editor-options';
import * as DirtyForm from '../../../app-state/actions/dirty-form.actions';
import { ApiServicesService } from '../services/api-services.service';
import { ToastrService } from 'ngx-toastr';
import { UploadImageDialogComponent } from "../../custom-kendo/upload-image-dialog/upload-image-dialog.component";
import { EditorComponent } from "@progress/kendo-angular-editor";

@Component({
  selector: 'app-send-invite',
  templateUrl: './send-invite.component.html',
  styleUrls: ['./send-invite.component.scss']
})
export class SendInviteComponent implements OnInit {
  //@ViewChild("sendinvitekendoeditor", { static: false }) sendinvitekendoeditor: any;
  @ViewChild("sendinviteimageupload") public sendinviteimageupload: UploadImageDialogComponent;
@Output() @ViewChild("sendinvitekendoeditor") public sendinvitekendoeditor: EditorComponent;
  
  formDirty = false;
  sendInfoForm: FormGroup;
  listCompany;
  bodyContent = '';
  @Input() public beneficiary = [];
  formDirtyFromDifferentControls = false;
  // public options = {
  //   ...FroalaEditorOptions.EditorOptions,
  //   events: {
  //     contentChanged: () => {
  //       this.setFormDirty();
  //       // this.isFormValidCheck();
  //     }
  //   }
  // };

  

  constructor(public dialog: MatDialog,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private petitionerApiService: ApiServicesService,
    private formBuilder: FormBuilder,
    private companyApiService: CompanyService,
    protected store: Store<any>) { }

  ngOnInit() {
    this.sendInfoForm = this.formBuilder.group({
      company: ['', [Validators.required]],
      sendInfoThroughEmailOrLink: ['', [Validators.required]],
      additionalNote: [''],
      body: [''],
      subject: ['', [Validators.required]],
      isEmailRequiredForLink: false,
      beneficiaryIds: ''
    });
    this.companyApiService.getCompanyHierarchyById(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
      this.listCompany = data;
    })
    if (this.beneficiary) {
      let ids = [];
      this.beneficiary.forEach(element => {
        ids.push(element.beneficiaryId);
      });
      this.sendInfoForm.patchValue({
        beneficiaryIds: ids
      });
    }
  }


  public sendinviteimageuploaddialog() {
    this.sendinviteimageupload.open();
  }

  setFormDirty() {
    this.formDirtyFromDifferentControls = true;
    this.store.dispatch(new DirtyForm.MarkDirtyFormAction({ dirty: true }));
  }

  closeForm() {
    if (this.formDirty) {
      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.activeModal.dismiss('Cross click');
          this.formDirty = false;
        }
      });
    } else {
      this.activeModal.dismiss('Cross click');
    }
  }

  inviteExternalBeneFormSub() {
    let payload = {
      "additionalNote": this.sendInfoForm.controls['additionalNote'].value,
      "beneficiaryIds": this.sendInfoForm.controls['beneficiaryIds'].value,
      //"body": this.sendInfoForm.controls['sendInfoThroughEmailOrLink'].value == 'EMAIL' ? this.bodyContent : this.sendInfoForm.controls['body'].value,
      "body": this.sendInfoForm.controls['sendInfoThroughEmailOrLink'].value == 'EMAIL' ? this.bodyContent : this.sendinvitekendoeditor.value,
      "companyId": this.sendInfoForm.controls['company'].value,
      "isEmailRequiredForLink": this.sendInfoForm.controls['isEmailRequiredForLink'].value,
      "sendInfoThroughEmailOrLink": this.sendInfoForm.controls['sendInfoThroughEmailOrLink'].value,
      "subject": this.sendInfoForm.controls['subject'].value
    };
    this.petitionerApiService.sendNotification(payload).subscribe((response: any) => {
      if (response.status == 200) {
        this.toastr.success(response.message, 'Success');
        this.closeForm();
      }
    });
  }

  public valueChange(value: any) {
    this.bodyContent = value;
    this.setFormDirty();

  }
}